import { defineStore } from 'pinia';
import apiservice from "@/services/apiservice.js";
import { useEventSearch } from './eventSearch';
import { i18n } from '@/main.js';
import colors from '@/colors.js'


const getColors = (aulas: any[],aulascolor:AulasColor) => {
  const uniqueAulas = [...new Set(aulas.map(el => {
    if(el.cadeira == "Feriados"){
      return "Feriado";
    }
    return el.cadeira
  }))];
  uniqueAulas.map((el, index) => {
    aulascolor[el] = colors[index];
  });
};

const setCurrentCalendar = (currentCalendario,aul: any[]) => {
  currentCalendario["2"] = aul.filter(el => el.idDiaSemana == 2);
  currentCalendario["3"] = aul.filter(el => el.idDiaSemana == 3);
  currentCalendario["4"] = aul.filter(el => el.idDiaSemana == 4);
  currentCalendario["5"] = aul.filter(el => el.idDiaSemana == 5);
  currentCalendario["6"] = aul.filter(el => el.idDiaSemana == 6);
  currentCalendario["7"] = aul.filter(el => el.idDiaSemana == 7);
  currentCalendario["1"] = aul.filter(el => el.idDiaSemana == 1);
}

type AulasColor = {
  [key: string]: {
    header: string;
    body: string;
  };
};

interface State {
  headerVisible: Boolean;
  currentAbortController: AbortController | null;
  aulas: any;
  isUpdatingHorario: boolean;
  aulascolor: AulasColor;
  currentCalendario: any;
}

export const useHorarios = defineStore({
  id: 'horarios',
  state: (): State => ({ 
    headerVisible: import.meta.env.VITE_APP_HEADER_VISIBILITY == "true",
    currentAbortController: null,
    aulas: [],
    isUpdatingHorario: false,
    aulascolor:{},
    currentCalendario: {}
  }),
  getters: {
    
  },
  actions: {
    setIsUpdatingHorario(val){
      this.isUpdatingHorario = val;
    },
    setHeaderVisibility(isVisible){
      this.headerVisible = isVisible
    },
    setAulas(aulas){
      let formattedAulas = aulas.map(el=>{
        const nomecadeira = el.cadeira == "Feriados" ? "Feriado" : el.cadeira
        return {
          ...el,
          cadeira: nomecadeira,
        }
      });
      this.aulas = formattedAulas;
    },
    fetchHorario(){
      if (this.currentAbortController) {
        this.currentAbortController.abort();
      }
      this.currentAbortController = new AbortController();
      this.isUpdatingHorario = true;
      const ev = useEventSearch();
      apiservice.fetchCalendariosWithSignal(
        ev.selectedWeek,
        ev.currentFilters,
        i18n.global.locale,
        this.currentAbortController.signal
      ).then(data => {
        if(data?.data){
          this.setAulas(data.data);
          getColors(this.aulas,this.aulascolor);
          setCurrentCalendar(this.currentCalendario,this.aulas);
          this.isUpdatingHorario = false;
        }
      }).catch(err => {
        this.isUpdatingHorario = false;
        console.log(err);
      })
    }
  }
});